import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { isArray } from 'lodash-es';
import { breakpointInfix, Breakpoint } from './breakpoints';
import { isDefined } from './validators';
function isSpacingProps(prop) {
  return typeof prop === 'number' || prop === 'auto' || prop === null;
}
export function unpackShorthand() {
  switch (arguments.length) {
    case 0:
      return [];
    case 1:
      return [arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 0 ? undefined : arguments[0]];
    case 2:
      return [arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1]];
    case 3:
      return [arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2], arguments.length <= 1 ? undefined : arguments[1]];
    case 4:
    default:
      return [arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2], arguments.length <= 3 ? undefined : arguments[3]];
  }
}
function convertShorthand() {
  var props = {};
  var defaultProps = {
    all: null,
    vert: null,
    horz: null,
    top: null,
    bottom: null,
    right: null,
    left: null
  };
  switch (arguments.length) {
    case 0:
      props = {};
      break;
    case 1:
      props = {
        all: arguments.length <= 0 ? undefined : arguments[0]
      };
      break;
    case 2:
      props = {
        vert: arguments.length <= 0 ? undefined : arguments[0],
        horz: arguments.length <= 1 ? undefined : arguments[1]
      };
      break;
    case 3:
      props = {
        top: arguments.length <= 0 ? undefined : arguments[0],
        horz: arguments.length <= 1 ? undefined : arguments[1],
        bottom: arguments.length <= 2 ? undefined : arguments[2]
      };
      break;
    case 4:
    default:
      if ((arguments.length <= 0 ? undefined : arguments[0]) === (arguments.length <= 2 ? undefined : arguments[2])) {
        props.vert = arguments.length <= 0 ? undefined : arguments[0];
      } else {
        props.top = arguments.length <= 0 ? undefined : arguments[0];
        props.bottom = arguments.length <= 2 ? undefined : arguments[2];
      }
      if ((arguments.length <= 1 ? undefined : arguments[1]) === (arguments.length <= 3 ? undefined : arguments[3])) {
        props.horz = arguments.length <= 1 ? undefined : arguments[1];
      } else {
        props.right = arguments.length <= 1 ? undefined : arguments[1];
        props.left = arguments.length <= 3 ? undefined : arguments[3];
      }
      break;
  }
  return _objectSpread(_objectSpread({}, defaultProps), props);
}
export function spacingArrayToObject(args) {
  var props = {
    xs: [],
    sm: [],
    md: [],
    lg: [],
    xl: []
  };
  Object.values(Breakpoint).forEach(function (bp) {
    args.forEach(function (arg) {
      if (isSpacingProps(arg)) {
        var _props$bp;
        (_props$bp = props[bp]) === null || _props$bp === void 0 || _props$bp.push(bp === 'xs' ? arg : null);
      } else {
        var _props$bp2, _arg$bp;
        (_props$bp2 = props[bp]) === null || _props$bp2 === void 0 || _props$bp2.push((_arg$bp = arg[bp]) !== null && _arg$bp !== void 0 ? _arg$bp : null);
      }
    });
  });
  return props;
}
export function mergeSpacingProps(props) {
  var spacing = {
    xs: [null],
    sm: [null],
    md: [null],
    lg: [null],
    xl: [null]
  };
  var merge = function merge(key, val) {
    val.forEach(function (v, index) {
      if (v === null) return;
      spacing[key][index] = v;
    });
  };
  if (Array.isArray(props.spacing)) {
    spacing = spacingArrayToObject(props.spacing);
  } else if (isDefined(props.spacing)) {
    spacing = _objectSpread(_objectSpread({}, spacing), props.spacing);
  }
  Object.keys(spacing).forEach(function (key) {
    spacing[key] = unpackShorthand.apply(void 0, _toConsumableArray(spacing[key]));
  });
  if (isDefined(props.spacingX)) {
    var x = isSpacingProps(props.spacingX) ? {
      'xs': props.spacingX
    } : props.spacingX;
    Object.keys(x).forEach(function (key) {
      var val = x[key];
      merge(key, [null, val !== null && val !== void 0 ? val : null, null, val !== null && val !== void 0 ? val : null]);
    });
  }
  if (isDefined(props.spacingY)) {
    var y = isSpacingProps(props.spacingY) ? {
      'xs': props.spacingY
    } : props.spacingY;
    Object.keys(y).forEach(function (key) {
      var val = y[key];
      merge(key, [val !== null && val !== void 0 ? val : null, null, val !== null && val !== void 0 ? val : null, null]);
    });
  }
  if (isDefined(props.spacingTop)) {
    var top = isSpacingProps(props.spacingTop) ? {
      'xs': props.spacingTop
    } : props.spacingTop;
    Object.keys(top).forEach(function (key) {
      var val = top[key];
      merge(key, [val !== null && val !== void 0 ? val : null, null, null, null]);
    });
  }
  if (isDefined(props.spacingRight)) {
    var right = isSpacingProps(props.spacingRight) ? {
      'xs': props.spacingRight
    } : props.spacingRight;
    Object.keys(right).forEach(function (key) {
      var val = right[key];
      merge(key, [null, val !== null && val !== void 0 ? val : null, null, null]);
    });
  }
  if (isDefined(props.spacingBottom)) {
    var bottom = isSpacingProps(props.spacingBottom) ? {
      'xs': props.spacingBottom
    } : props.spacingBottom;
    Object.keys(bottom).forEach(function (key) {
      var val = bottom[key];
      merge(key, [null, null, val !== null && val !== void 0 ? val : null, null]);
    });
  }
  if (isDefined(props.spacingLeft)) {
    var left = isSpacingProps(props.spacingLeft) ? {
      'xs': props.spacingLeft
    } : props.spacingLeft;
    Object.keys(left).forEach(function (key) {
      var val = left[key];
      merge(key, [null, null, null, val !== null && val !== void 0 ? val : null]);
    });
  }
  return spacing;
}
export function spacingClass(type, args) {
  var typeCode = '';
  var props = {};
  switch (type) {
    case 'padding':
      typeCode = 'p';
      break;
    case 'margin':
      typeCode = 'm';
      break;
  }
  if (isArray(args)) {
    props = spacingArrayToObject(args);
  } else {
    props = args;
  }
  var classes = Object.keys(props).map(function (breakpoint) {
    var _convertShorthand = convertShorthand.apply(void 0, _toConsumableArray(props[breakpoint])),
      all = _convertShorthand.all,
      vert = _convertShorthand.vert,
      horz = _convertShorthand.horz,
      top = _convertShorthand.top,
      left = _convertShorthand.left,
      bottom = _convertShorthand.bottom,
      right = _convertShorthand.right;
    var infix = breakpointInfix(breakpoint);
    return cn(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(typeCode, "--").concat(all).concat(infix), all !== null), "".concat(typeCode, "--y-").concat(vert).concat(infix), vert !== null), "".concat(typeCode, "--x-").concat(horz).concat(infix), horz !== null), "".concat(typeCode, "--t-").concat(top).concat(infix), top !== null), "".concat(typeCode, "--r-").concat(right).concat(infix), right !== null), "".concat(typeCode, "--b-").concat(bottom).concat(infix), bottom !== null), "".concat(typeCode, "--l-").concat(left).concat(infix), left !== null));
  });
  return cn(classes);
}
export function paddingClass(args) {
  return spacingClass('padding', args);
}
export function marginClass(args) {
  return spacingClass('margin', args);
}